import { Button, DialogActions, DialogContent, DialogTitle, Divider, Slide, Stack, Typography } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { forwardRef } from 'react';
import AquantCancelIcon from '../resources/images/aq-cancel.svg';
import './DeleteProjectDialog.scss';
import SiDialog from './SiDialog';

type Props = {
    config: any;
    open: boolean;
    onClose: () => void;
    onSubmit: (config) => void;
};

const Transition = forwardRef(
    (
        props: TransitionProps & {
            children: React.ReactElement;
        },
        ref: React.Ref<unknown>,
    ) => <Slide direction="up" ref={ref} {...props} />,
);

const DeleteProjectDialog = (props: Props) => {
    const { open, config, onSubmit, onClose } = props;
    return (
        <SiDialog open={open} onClose={onClose} TransitionComponent={Transition}>
            <DialogTitle>
                <Stack className="DialogTitle">
                    <Typography className="DialogTitleText">Are you sure?</Typography>
                    <img src={AquantCancelIcon} onClick={onClose} alt="cancel icon" className="CancelIcon" />
                </Stack>
            </DialogTitle>
            <Divider />
            <DialogContent classes={{ root: 'DeleteDialogContent' }}>
                <Typography
                    style={{ color: '#4A4A4A' }}
                    fontWeight={400}
                    letterSpacing="4%"
                    lineHeight="22.4px"
                    fontSize="16px"
                >
                    Are you sure you want to delete this project? <br />
                    This action is not reversible.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disableRipple className="DialogActionBtn">
                    Cancel
                </Button>
                <Button
                    onClick={() => onSubmit(config)}
                    variant="contained"
                    disableRipple
                    className="DialogActionBtnContained"
                >
                    Delete
                </Button>
            </DialogActions>
        </SiDialog>
    );
};

export default DeleteProjectDialog;
